import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { TextComponent } from '../TextComponent';
import { Button } from '../Button';
import { useTheme } from '../../providers/theme';

interface DialogAlertType{
  handleDelete: () => void | Promise<void>;
  dialogOpen: boolean;
  handleClose: () => void;
  dialogTitle?: string;
  dialogMessage?: string;

}

export function DialogAlert({
  handleDelete, dialogOpen, handleClose, dialogTitle, dialogMessage
}: DialogAlertType) {
  const { theme } = useTheme();

  return (
    <Dialog open={dialogOpen} onClose={handleClose} sx={{ zIndex: 9999 }}>
      <DialogTitle>
        <TextComponent
          fontWeight='bold'
          fontSize='18px'
          color='#000'
        >
          {dialogTitle}
        </TextComponent>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <TextComponent
            color='#000'
          >
            {dialogMessage}
          </TextComponent>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          id='cancel'
          onClick={handleClose}
          children='CANCELAR'
          type='button'
          color={theme.colors.green}
          sxhover={theme.colors.hoverGreen}
        />
        <Button
          id='delete'
          onClick={handleDelete}
          children='DELETAR'
          type='button'
          color={theme.colors.red}
          sxhover={theme.colors.hoverRed}
        />
      </DialogActions>
    </Dialog>
  );
}
